<div class="loader">
  <div class="logo-loader"><img src="assets/svg/logo-square-{{light ? 'light' : 'grey'}}.svg"></div>
</div>
<div #content
    class="content">
    <ng-content></ng-content>
</div>